import { render, staticRenderFns } from "./left-content.vue?vue&type=template&id=2f619e9b&scoped=true&"
import script from "./left-content.vue?vue&type=script&lang=js&"
export * from "./left-content.vue?vue&type=script&lang=js&"
import style0 from "./left-content.vue?vue&type=style&index=0&id=2f619e9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f619e9b",
  null
  
)

export default component.exports